// import React from 'react';
// import './WhatsAppButton.css'; // Import the CSS for styling
// import { PiWhatsappLogoLight } from 'react-icons/pi';

// const WhatsAppButton = () => {
//   const phoneNumber = '+34688681253'; // Replace with your phone number
//   const defaultMessage = 'Hello, I would like to know more about your services.';

//   const handleClick = () => {
//     const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="whatsapp-button" onClick={handleClick}>
//       {/* <img
//         src="https://image.shutterstock.com/image-vector/social-media-icon-design-template-260nw-1905087507.jpg" // Replace with the WhatsApp icon URL
//         alt="WhatsApp"
//         className="whatsapp-icon"
//       /> */}
//       <PiWhatsappLogoLight className="whatsapp-icon" />
//     </div>
//   );
// };

// export default WhatsAppButton;

import React from 'react';
import './WhatsAppButton.css';
import { PiWhatsappLogoLight } from 'react-icons/pi';
import { FaInstagram, FaLinkedin, FaTiktok } from 'react-icons/fa';

const SocialMediaButtons = () => {
  // WhatsApp configuration
  const phoneNumber = '+34688681253';
  const defaultMessage = 'Hello, I would like to know more about your services.';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, '_blank');
  };

  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/aloka.app', '_blank');
  };

  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/company/alokapp/', '_blank');
  };

  const handleTikTokClick = () => {
    window.open('https://www.tiktok.com/@aloka.app', '_blank');
  };

  return (
    <>
      {/* Mobile - Only WhatsApp and Instagram */}
      <div className="social-media-container mobile-only">
        <div className="social-media-button" onClick={handleWhatsAppClick}>
          <PiWhatsappLogoLight className="social-icon whatsapp-icon" />
        </div>
        <div className="social-media-button" onClick={handleInstagramClick}>
          <FaInstagram className="social-icon instagram-icon" />
        </div>
      </div>

      {/* Desktop - All four icons */}
      <div className="social-media-container desktop-only">
        <div className="social-media-button" onClick={handleWhatsAppClick}>
          <PiWhatsappLogoLight className="social-icon whatsapp-icon" />
        </div>
        <div className="social-media-button" onClick={handleInstagramClick}>
          <FaInstagram className="social-icon instagram-icon" />
        </div>
        <div className="social-media-button" onClick={handleLinkedInClick}>
          <FaLinkedin className="social-icon linkedin-icon" />
        </div>
        <div className="social-media-button" onClick={handleTikTokClick}>
          <FaTiktok className="social-icon tiktok-icon" />
        </div>
      </div>
    </>
  );
};

export default SocialMediaButtons;
